export default __webpack_public_path__ + "static/media/button@2x.4b8410c2.png";